import { render } from "./authItem.vue?vue&type=template&id=651e2f4f&scoped=true"
import script from "./authItem.vue?vue&type=script&lang=js"
export * from "./authItem.vue?vue&type=script&lang=js"

import "./authItem.vue?vue&type=style&index=0&id=651e2f4f&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE\\zoopay\\zoopay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651e2f4f"]])

export default __exports__